export default "__VITE_PUBLIC_ASSET__90e82e72__"